<template>
  <chart-container :titleChart="titleChart" @onCSVDownload="downloadCSVGraph()" @zoomEnabled="zoomEnabled" @zoomDisabled="zoomDisabled" :downloadId="downloadId" :specificSiteId="specificSiteId" :zoomGraphValue="zoomGraphValue" :downloadShow="dataSource.categories && Object.keys(dataSource.categories).length > 0">
    <div class="card-text-strong d-inline" slot="header">
      <span class="float-right enrol-tabs">
        <b-tabs v-model="tabIndexCancelledTelehealthVisits">
          <b-tab v-for="(tabName, index) in cancelledTelehealthVisitsTabList" :key="index" :title="tabName" />
        </b-tabs>
      </span>
    </div>
    <fusioncharts slot="body" style="width: 100%;" :type="type" :width="width" :height="height" :dataFormat="dataFormat" :dataSource="dataSource" dataEmptyMessage="No Data In" ref="timeActiveStatusPercentage" v-if="dataSource.categories && Object.keys(dataSource.categories).length > 0" />
    <div slot="body" v-else class="align-center p-60">
      <div class="card-text-title no-data" v-if="dataLoaded">No Data In</div>
    </div>
    <div slot="body" class="text-left min-height-0" v-if="dataSource.categories && Object.keys(dataSource.categories).length > 0">
      <span @click="zoomOutChart()" class="pl-10 pr-5 remove-zoom-icons">
        <img src="/static/img/icon-zoomout.svg" class="download_graph cursor_pointer" aria-haspopup="true" aria-expanded="false" title="Zoom Out" />
      </span>
      <span @click="zoomInChart()" class="remove-zoom-icons">
        <img src="/static/img/icon-zoomin.svg" class="download_graph cursor_pointer" aria-haspopup="true" aria-expanded="false" title="Zoom In" />
      </span>
    </div>
  </chart-container>
</template>
<script>
import _cloneDeep from "lodash/cloneDeep";
import { downloadCSV, getSiteID } from "../../services/visualization/data-management";
import * as studyComplianceManagement from "@/services/visualization/study-compliance";
import ChartContainer from "@/components/containers/chart-container";

const dataSources = {
  chart: {
    xaxisname: "",
    yaxisname: "Percentage Cancelled",
    xAxisNameFontColor: "#959fa4",
    xAxisNameFont: "RobotoMedium",
    xAxisNameFontSize: "9px",
    labelFontSize: "10px",
    labelFont: "RobotoRegular",
    labelFontColor: "#a3a3a3",
    yAxisNameFontColor: "#a3a3a3",
    yAxisNameFont: "RobotoMedium",
    yAxisNameFontSize: "9px",
    yAxisValueFont: "RobotoMedium",
    yAxisValueFontSize: "10px",
    yAxisValueFontColor: "#a3a3a3",
    theme: "fusion",
    legendPosition: "right",
    legendItemFont: "RobotoRegular",
    legendItemFontColor: "#666669",
    legendCaptionAlignment: "center",
    legendItemFontSize: "10px",
    legendIconBgAlpha: "100",
    legendIconBorderThickness: "6",
    baseFontSize: "10",
    tooltipBorderAlpha: "0",
    toolTipBgAlpha: "0",
    showToolTipShadow: "0",
    scrollheight: "10",
    divLineAlpha: "0",
    divLineDashed: "0",
    scrollColor: "#cccccc",
    numbersuffix: "%",
    numVisiblePlot: "20",
    showHoverEffect: "1",
    useEllipsesWhenOverflow: "1",
    maxColWidth: "15",
    plotHighlightEffect: "fadeout",
    plotSpacePercent: 30,
    showXAxisLine: true,
    showYAxisLine: true,
    xaxislinethickness: "1",
    yaxislinethickness: "1",
    xAxisLineColor: "#b0bac9",
    yAxisLineColor: "#b0bac9",
    chartBottomMargin: "0",
    xAxisNamePadding: "5",
    decimals: "0",
    labelDisplay: "wrap",
    maxLabelHeight: "30",
    yAxisValueDecimals: "0"
  },
  categories: [],
  dataset: []
};
export default {
  components: { ChartContainer },
  props: {
    cancelledTelehealthVisitsRaw: [Object, Array],
    zoomGraphValue: { type: String, default: "" },
    specificSiteId: { type: Array, default: () => {} },
    xAxisName: { type: String, default: "" },
    downloadId: { type: String, default: "" },
    titleChart: { type: String, default: "" },
    subtitleChart: { type: String, default: "" },
    dataForDownloadCsv: [Object],
    sitesSelected: { type: Array, default: () => ["all"] },
    countrySelected: { default: () => "all" },
    dataLoaded: { type: Boolean, default: false },
    filterTriggered: { type: Boolean, default: false },
    cancelledTelehealthVisitsTabList: {
      type: [Object, Array],
      default: () => ["Total", "Countries"]
    }
  },
  data() {
    return {
      series: null,
      type: "scrollColumn2d",
      width: "100%",
      height: "250",
      dataFormat: "json",
      dataSource: dataSources,
      zoomGraphValueChild: "",
      curZoomLevel: 0,
      maxZoomLevel: 3,
      maxColumn: 0,
      todayDate: "",
      tDateShow: true,
      getSiteID,
      tabIndexCancelledTelehealthVisits: 0
    };
  },
  watch: {
    cancelledTelehealthVisitsRaw: function(newValue) {
      this.series = newValue ? studyComplianceManagement.getCancelledTelehealthVisits(newValue, this.countrySelected, this.sitesSelected, this.tabIndexCancelledTelehealthVisits) || { series: {}, csvData: {} } : { series: {}, csvData: {} };
    },
    filterTriggered: function() {
      this.series = studyComplianceManagement.getCancelledTelehealthVisits(this.cancelledTelehealthVisitsRaw, this.countrySelected, this.sitesSelected, this.tabIndexCancelledTelehealthVisits) || { series: {}, csvData: {} };
    },
    tabIndexCancelledTelehealthVisits: function(newValue) {
      this.tabIndexCancelledTelehealthVisits = newValue;
      const countrySelected = this.countrySelected === "all" ? this.countryList : this.countrySelected;
      const sitesSelected = this.sitesSelected[0] === "all" ? this.allSitesList : this.sitesSelected;
      this.series = studyComplianceManagement.getCancelledTelehealthVisits(this.cancelledTelehealthVisitsRaw, countrySelected, sitesSelected, newValue) || { series: {}, csvData: {} };
      this.generateAxisTimeActivities(this.tabIndexCancelledTelehealthVisits);
    },
    zoomGraphValue: function(newVal) {
      this.zoomGraphValueChild = newVal;
      if (newVal == "") {
        this.height = "250";
      }
    },
    series: function(newValue) {
      if (newValue.series.categories) {
        this.initGraph(newValue.series);
      } else {
        const dataSources = {};
        dataSources.categories = null;
        this.dataSource = dataSources;
      }
    }
  },

  methods: {
    zoomEnabled() {
      this.$emit("zoomEnabled");
      this.height = "400";
      this.zoomTrigger = true;
    },
    zoomDisabled() {
      this.$emit("zoomDisabled");
      this.height = "250";
      this.zoomTrigger = false;
    },
    generateAxisTimeActivities(tab = 0) {
      let axisName = "";
      switch (tab) {
        case 0:
          axisName = "";
          break;
        case 1:
          axisName = "Countries";
          break;
        case 2:
          axisName = "Sites";
          break;
        default:
          axisName = "";
          break;
      }

      return axisName;
    },
    generateCsvHeaders(tabIndexCancelledTelehealthVisits) {
      const headers = ["Percentage Site Team", "Percentage Home Health", "Percentage Participant"];
      switch (tabIndexCancelledTelehealthVisits) {
        case 0:
          headers.unshift("Total");
          break;
        case 1:
          headers.unshift("Countries");
          break;
        case 2:
          headers.unshift("Sites");
          break;
        default:
          break;
      }
      return headers;
    },

    downloadCSVGraph() {
      const csvHeaders = this.generateCsvHeaders(this.tabIndexCancelledTelehealthVisits);
      this.tDateShow = true;
      const csvContentArray = [];
      this.series.csvData.categories.map((row, index) => {
        const siteTeamValue = Number(this.series.csvData.dataset[0][index].value);
        const homeHealthValue = Number(this.series.csvData.dataset[1][index].value);
        const participantValue = Number(this.series.csvData.dataset[2][index].value);

        csvContentArray.push([row.label, Number.isNaN(siteTeamValue) ? "0%" : Number(siteTeamValue).toFixed(2) + "%", Number.isNaN(homeHealthValue) ? "0%" : Number(homeHealthValue).toFixed(2) + "%", Number.isNaN(participantValue) ? "0%" : Number(participantValue).toFixed(2) + "%"]);
      });

      downloadCSV(this.titleChart, csvHeaders, csvContentArray, this.specificSiteId);
    },
    getNumVisPlotByZoom() {
      let numVisPlot = 0;
      switch (this.curZoomLevel) {
        case 0:
          numVisPlot = 0;
          break;
        case 1:
          numVisPlot = Math.round(0.75 * this.maxColumn);
          break;
        case 2:
          numVisPlot = Math.round(0.5 * this.maxColumn);
          break;
        case 3:
          numVisPlot = Math.round(0.2 * this.maxColumn);
          break;
        default:
          break;
      }
      return numVisPlot;
    },
    zoomInChart() {
      if (this.curZoomLevel < this.maxZoomLevel) {
        this.curZoomLevel = this.curZoomLevel + 1;
        const chartRef = this.$refs.timeActiveStatusPercentage.chartObj;
        const data = chartRef.getJSONData();
        const numVisPlot = this.getNumVisPlotByZoom();
        data.chart.numvisibleplot = numVisPlot;
        chartRef.setJSONData(data);
      }
    },
    zoomOutChart() {
      if (this.curZoomLevel > 0) {
        this.curZoomLevel = this.curZoomLevel - 1;
        const chartRef = this.$refs.timeActiveStatusPercentage.chartObj;
        const data = chartRef.getJSONData();
        const numVisPlot = this.getNumVisPlotByZoom();
        data.chart.numvisibleplot = numVisPlot;
        chartRef.setJSONData(data);
      }
    },
    initGraph(newValue) {
      const { categories, dataset } = newValue;
      const datasources = _cloneDeep(dataSources);
      dataset[0] = {
        ...dataset[0]
      };
      dataset[1] = {
        ...dataset[1]
      };
      dataset[2] = {
        ...dataset[2]
      };
      if (categories && categories[0].category.length > 0) {
        //update lable for site view changes
        if (this.cancelledTelehealthVisitsTabList.length == 2 && categories[0].category[0].label == "Total Cancelled Telehealth Visits") {
          categories[0].category[0].label = this.sitesSelected[0] + " " + "Cancelled Telehealth Visits";
        }

        datasources.categories = [...categories];
        datasources.dataset = dataset;
        this.maxColumn = categories[0].category.length;
      }
      datasources.chart.numvisibleplot = 0;
      datasources.chart.xaxisname = this.generateAxisTimeActivities(this.tabIndexCancelledTelehealthVisits);
      this.dataSource = datasources;
    }
  },
  mounted() {
    if (this.series && this.series.series.categories) {
      this.initGraph(this.series.series);
    }
  }
};
</script>
